import swiper from '../directives/media/swiper';

/**
 * Hero controls.
 */
export default function pageBannerSection() {
  
  // Is there a hero swiper?
  const element = document.querySelector('.page-banner_swiper');
  if (!element) return;

  // Load 'er up
  swiper(element, swiper => {

    // Settings
    let settings = JSON.parse(element.dataset.pageBannerSwiper);
    if (!settings) return;

    // Events
    settings.on = {

      afterInit: () => {
        element.classList.add('-started');
      },

      slideChangeTransitionStart: () => {

        let currentSlideBG = document.querySelector('.swiper-slide-visible .page-banner_swiper_slide_bg');
        currentSlideBG.classList.remove('-scaling');
      },

      slideChangeTransitionEnd: () => {

        let currentSlideBG = document.querySelector('.swiper-slide-visible .page-banner_swiper_slide_bg');
        currentSlideBG.classList.add('-scaling');
      },

    }

    // Init
    const slides = element.querySelectorAll('.swiper-slide');
    if (slides.length >= 1) {
      const swiperInstance = new swiper(element, settings);
    }
  });
}



// WEBPACK FOOTER //
// ./source/scripts/sections/page-banner.js